import KeenSlider from "keen-slider";
import { watch } from "vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import keenNavigationPlugin from "@/shared/keen-slider/plugins/keen-navigation-plugin";

const initMobileAppFeatures = () => {
    const root = document.querySelector(".mobile-app-features");
    if (!root) {
        return;
    }

    let isMobileVersionInited = false;
    let isDesktopVersionInited = false;

    const initForBreakpoint = (isSm: boolean) => {
        if (isSm) {
            if (!isMobileVersionInited) {
                const featureItems = root.querySelectorAll(".mobile-app-feature");
                for (const featureItem of featureItems) {
                    featureItem.addEventListener("click", function (e) {
                        const elem = e.currentTarget;
                        if (elem.classList.contains("active")) {
                            return;
                        }
                        root.querySelectorAll(".mobile-app-feature, .mobile-app-features__phone-image").forEach(
                            (imageElem) => imageElem.classList.remove("active")
                        );
                        const id = elem.dataset.id;
                        elem.classList.add("active");
                        root.querySelector(`.mobile-app-features__phone-image[data-id="${id}"]`).classList.add(
                            "active"
                        );
                    });
                }

                isMobileVersionInited = true;
            }
        } else if (!isDesktopVersionInited) {
            root.querySelectorAll(".mobile-app-feature__container").forEach((imageElem) =>
                imageElem.classList.add("initialized")
            );

            const sliderElem = root.querySelector<HTMLElement>(".mobile-app-features__mobile");
            new KeenSlider(
                sliderElem,
                {
                    slides: {
                        perView: 1.03,
                    },
                    selector: ".mobile-app-feature__container",
                    slideChanged: (sliderInstance) => {
                        const featuresMobileElem = document.querySelector(".mobile-app-features__mobile");
                        const slide = sliderInstance.track.details.rel;
                        Array.from(featuresMobileElem.children).forEach(function (feature, idx) {
                            if (idx === slide) {
                                feature.querySelector(".mobile-app-feature").classList.add("active");
                            } else {
                                feature.querySelector(".mobile-app-feature").classList.remove("active");
                            }
                        });
                    },
                },
                [keenNavigationPlugin]
            );

            const firstFeatureElem = document.querySelector(".mobile-app-features__mobile .mobile-app-feature");
            firstFeatureElem.classList.add("active");
            isDesktopVersionInited = true;
        }
    };

    const isSm = useBreakpoints("sm");

    initForBreakpoint(isSm.value);

    watch(isSm, (newVal) => initForBreakpoint(newVal));
};

document.ready(() => {
    initMobileAppFeatures();
});
